<template>
  <div class="">
    <!-- 顶级导航盒子 -->
    <div class="dui-navbar" :class="current>=0?'b_c_fff':''">
      <div class="flex a_i_c a_i_c h_66 w_1200 m_lr_auto">
        <img
          class="w_70 m_r_50"
          src="http://igstech.com.cn/resources/logo/logo.png"
          @click="onGoHome"
        />
        <!-- 菜单数组 -->
        <div
          class="m_r_40 h_66 l_h_66 cursor_p btn pos_r f_s_14 f_w_600"
          v-for="(item, index) in list"
          :key="item.lable"
        >
          <div class="category-item" @mouseover="onMouseover(item, index)" @click="onRootClick(item)">{{item.lable}}</div>
        </div>
      </div>
    </div>
    <!-- 弹出层 -->
    <div class="shade-box" v-show="current>=0">
      <!-- 遮照 -->
      <div class="shade-bg">
        <!-- 子菜单盒子 -->
        <div class="sh w_1200 m_lr_auto m_b_100" @mouseleave="onMouseleave">
          <div v-for="(item, index) in list" :key="item.lable">
            <div v-show="current === index">
              <dui-dropdown-menu :list="item.products" @success="onMouseleave"></dui-dropdown-menu>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import DuiDropdownMenu from "./dui-dropdown-menu.vue";
/**
 * 顶部导航组件
 */
export default {
  name: "NavigationTop",
  components: { DuiDropdownMenu },
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      current: -1
    };
  },
  methods: {
    onGoHome() {
        this.onMouseleave()
      this.$router.push("/");
    },
    onRootClick(item) {
      if (item.page) {
        this.onMouseleave()
        this.$router.push({
          path: "/" + item.page
        });
      }
    },
    /**
     * 鼠标经过事件
     */
    onMouseover (item, index) {
      if (item.products) {
        this.current = index; 
      }
    },
    /**
     * 鼠标离开事件
     */
    onMouseleave() {
      setTimeout(() => {
        this.current = -1;
      }, 100);
    }
  }
};
</script>
<style>
.dui-navbar {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 102;
}
.dui-navbar:hover {
  background-color: #fff;
}
.category-item {
  height: 64px;
}
.category-item:hover {
  border-bottom: 2px solid #333333;
}
.shade-box {
  padding-top: 66px;
  background-color: #00000088;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 101;
  transition: all 0.6s ease;
}
.shade-bg {
  background-color: #fff;
  padding-bottom: 50px;
}
</style>